import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
import {getTranslation} from "../../../helpers/get-translation";
import {HINT_BOMB3, HINT_CLUE1, HINT_CLUE2, HINT_LETTERS4} from "../../../helpers/cloud-function/hint-types";


const styles = theme => ({
	hint:{
		"display": "flex",
		"align-items": "center",
		"padding": "10px",
		"border": "1px solid",
		"border-radius": "40px",
		"margin": "10px 0",
		fontSize: "16px",
		cursor: "pointer",

		"& img":{
			"min-width": "50px",
			"width": "50px",
			"margin-right": "20px",
		},

		"& pre":{
			fontSize: "16px",
			"white-space": "pre-wrap",
			"word-wrap": "break-word",
			"line-height": "26px",
			"margin-top": "8px",
			"margin-bottom": "8px",
		},

		"&:hover": {
			background: "#f4f4f4"
		}
	},
	hintContent:{
		width: "100%",
		textAlign: "left"
	},
	textAlignCenter:{
		textAlign: "center"
	},
	loading:{
		marginRight: "50px",
	},
	"@media (max-width: 400px)": {
		hint: {
			"margin": "8px 0",
			fontSize: "14px",
			"& img": {
				"min-width": "40px",
				"width": "40px",
			}
		},
		loading:{
			marginRight: "30px",
		},
	}
});


class Hint extends Component{

	state = {
		isPurchased: false
	};

	getHintContent = (type, hintValue) => {
		if(type === HINT_CLUE1 || type === HINT_CLUE2 || type === HINT_BOMB3){
			return <span>{hintValue}</span>
		} else if(type === HINT_LETTERS4){
			return <pre>{hintValue}</pre>

		}
	};

	onClick = (type)=>{
		// this.setState({isLoading: true})
			const isPurchased = this.state.isPurchased || !!this.props.hintValue;
			this.setState({isPurchased: true});
			this.props.onHintClick(type, isPurchased)
	};

	getHintTextContainerClass = (classes, hintValue, hintType) => {
		const hintSpanClass = [classes.hintContent];
		if(hintValue === null || hintValue && (hintType === HINT_BOMB3 || hintType === HINT_LETTERS4)){
			hintSpanClass.push(classes.textAlignCenter)
		}

		return hintSpanClass
	};

	render(){
		const { classes, hintType, hint, hintValue} = this.props;

		const imageOpacity = hintValue ? "0.4" : "1";
		const hintText = hintValue ? this.getHintContent(hintType, hintValue) : getTranslation(hint.text);
		const borderColor = hintValue ? hint.alphaColor : hint.color;

		const hintTextContainerClass = this.getHintTextContainerClass(classes, hintValue, hintType);
		const hintTextColor = hintValue ? "#484848" : hint.color;

		return(
			<div
				className={classes.hint}
				key={`key-${hintType}`}
				style={{borderColor: borderColor}}
				onClick={() => this.onClick(hintType)}>
				<img src={hint.img} style={{opacity: imageOpacity}}/>
				<span style={{color: hintTextColor}} className={hintTextContainerClass.join(" ")}>
					{hintValue === null ? <CircularProgress className={classes.loading}/> : hintText}
				</span>
			</div>
		)
	}
}

Hint.propTypes = {
	hintType: PropTypes.string.isRequired,
	hintValue: PropTypes.string,

	hint: PropTypes.object.isRequired,

	classes: PropTypes.shape({
		hint: PropTypes.string.isRequired
	}).isRequired,

}


export default withStyles(styles)(Hint);
